export const sitePages = [
  {
    text: "Page d'accueil Alkimeo",
    value: "/",
  },
  {
    text: "Page Changement d'usage Alkimeo",
    value: "/changement-usage",
  },
  {
    text: "Page Changement de destination Alkimeo",
    value: "/changement-destination",
  },
  {
    text: "Page transactions Alkimeo",
    value: "/transactions",
  },
  {
    text: "Page Sortir du labyrinthe Alkimeo",
    value: "/sortir-du-labyrinthe",
  },
  {
    text: "Page Actualités Alkimeo",
    value: "/actualite",
  },
  {
    text: "Page Nous contacter Alkimeo",
    value: "/contact",
  },
  {
    text: "Page d'accueil La compensation",
    value: "/",
  },
  {
    text: "Page Changement d'usage La compensation",
    value: "/changement-usage",
  },
  {
    text: "Page Changement de destination La compensation",
    value: "/changement-destination",
  },
	{
    text: "Page Nous contacter La compensation",
    value: "/contact",
  },
];
